import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40bec4cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "overspan" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allArr, (allitem, indexall) => {
    return (_openBlock(), _createElementBlock("div", {
      class: "task-box",
      key: indexall
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allitem, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(allitem.length<3?'task-msg2':'task-msg'),
          key: index
        }, [
          _createElementVNode("p", null, _toDisplayString(item.title), 1),
          _createVNode(_component_a_tooltip, { placement: "top" }, {
            title: _withCtx(() => [
              _createElementVNode("span", null, [
                _createTextVNode(_toDisplayString(item.firstData), 1),
                _createElementVNode("span", null, "/" + _toDisplayString(item.secondData), 1)
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, [
                _createTextVNode(_toDisplayString(item.firstData), 1),
                _createElementVNode("span", null, "/" + _toDisplayString(item.secondData), 1)
              ])
            ]),
            _: 2
          }, 1024)
        ], 2))
      }), 128))
    ]))
  }), 128))
}